import React from 'react';
import { motion } from 'framer-motion';

const FancyLoader = ({ type = 'default' }) => {
  // Spinner animation variants
  const spinnerVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  // Pulse animation variants
  const pulseVariants = {
    animate: {
      scale: [1, 1.2, 1],
      opacity: [0.5, 1, 0.5],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  // Progress bar animation variants
  const progressVariants = {
    initial: { width: "0%" },
    animate: {
      width: "100%",
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  // Atom spinner animation
  const atomVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  const orbitVariants = {
    animate: {
      rotateX: [0, 360],
      rotateY: [0, 360],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "linear"
      }
    }
  };

  const renderLoader = () => {
    switch(type) {
      case 'spinner':
        return (
          <motion.div
            className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full"
            variants={spinnerVariants}
            animate="animate"
          />
        );
      
      case 'pulse':
        return (
          <motion.div
            className="w-16 h-16 bg-blue-500 rounded-full"
            variants={pulseVariants}
            animate="animate"
          />
        );
      
      case 'progress':
        return (
          <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden">
            <motion.div
              className="h-full bg-blue-500"
              variants={progressVariants}
              initial="initial"
              animate="animate"
            />
          </div>
        );
      
      case 'atom':
        return (
          <div className="relative w-24 h-24">
            <motion.div
              className="absolute inset-0"
              variants={atomVariants}
              animate="animate"
            >
              <div className="absolute w-full h-full border-4 border-blue-500 rounded-full" />
              <div className="absolute w-full h-full border-4 border-blue-500 rounded-full rotate-60" />
              <div className="absolute w-full h-full border-4 border-blue-500 rounded-full -rotate-60" />
            </motion.div>
            <motion.div
              className="absolute top-1/2 left-1/2 w-4 h-4 -mt-2 -ml-2 bg-blue-500 rounded-full"
              variants={pulseVariants}
              animate="animate"
            />
          </div>
        );
      
      default:
        return (
          <div className="space-y-8">
            <motion.div
              className="flex gap-2 justify-center"
              animate={{
                transition: { staggerChildren: 0.2 }
              }}
            >
              {[...Array(3)].map((_, i) => (
                <motion.div
                  key={i}
                  className="w-4 h-4 bg-blue-500 rounded-full"
                  animate={{
                    y: ["0%", "-100%", "0%"],
                    backgroundColor: ["#3B82F6", "#60A5FA", "#3B82F6"],
                  }}
                  transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: i * 0.2
                  }}
                />
              ))}
            </motion.div>
            <motion.div
              className="mx-auto w-32 text-center text-gray-600 font-medium"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              Loading...
            </motion.div>
          </div>
        );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[200px] w-full">
      {renderLoader()}
    </div>
  );
};

export default FancyLoader;